import { FinancialAccountSubtype } from '../../__generated__/globalTypes';

export type InvestmentTaxTreatment = 'TAXABLE' | 'TAX_DEFERRED' | 'TAX_FREE' | 'TAX_ADVANTAGED';

const TAX_TREATMENT_BY_SUBTYPE: Partial<Record<FinancialAccountSubtype, InvestmentTaxTreatment>> = {
  [FinancialAccountSubtype.Brokerage]: 'TAXABLE',
  [FinancialAccountSubtype.CryptoExchange]: 'TAXABLE',
  [FinancialAccountSubtype.Trust]: 'TAXABLE',
  [FinancialAccountSubtype.Ugma]: 'TAXABLE',
  [FinancialAccountSubtype.Utma]: 'TAXABLE',
  [FinancialAccountSubtype.Ira]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.SepIra]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.SimpleIra]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.Plan_401K]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.Plan_401A]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.Plan_403B]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.Plan_457B]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.Pension]: 'TAX_DEFERRED',
  [FinancialAccountSubtype.Roth]: 'TAX_FREE',
  [FinancialAccountSubtype.Roth_401K]: 'TAX_FREE',
  [FinancialAccountSubtype.Hsa]: 'TAX_ADVANTAGED',
  [FinancialAccountSubtype.Plan_529]: 'TAX_ADVANTAGED',
};

const TAX_TREATMENT_LABELS: Record<InvestmentTaxTreatment, string> = {
  TAXABLE: 'Taxable',
  TAX_DEFERRED: 'Tax-deferred',
  TAX_FREE: 'Tax-free',
  TAX_ADVANTAGED: 'Tax-advantaged',
};

/** How an investment subtype is taxed, or null for a subtype the Investments section does not cover. */
export function investmentTaxTreatment(
  subtype: FinancialAccountSubtype | null | undefined
): InvestmentTaxTreatment | null {
  return (subtype && TAX_TREATMENT_BY_SUBTYPE[subtype]) || null;
}

export function formatInvestmentTaxTreatment(treatment: InvestmentTaxTreatment): string {
  return TAX_TREATMENT_LABELS[treatment];
}

/** Whether the subtype can carry required minimum distributions: the tax-deferred ones only. */
export function hasRequiredDistributions(subtype: FinancialAccountSubtype | null | undefined): boolean {
  return investmentTaxTreatment(subtype) === 'TAX_DEFERRED';
}
